// extracted by mini-css-extract-plugin
module.exports = {"catalog":"CategoryPageNews_catalog__817ti","event":"CategoryPageNews_event__dyAsi","divider":"CategoryPageNews_divider__t5ano"};